import { InlineImage } from "../../components/InlineImage";

/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function T1450E1750() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Neerbosch tussen 1450 en 1750</h1>

          <h3>Neerbosch </h3>
          <InlineImage image="neerbosch/neerbosch_1750.jpg" width={300} subscript="Neerbosch in 1750" />
          <p>
            Wat er in Neerbosch gebeurd in de periode van 300 jaar tussen 1450 en 1750 lijkt niet veel te zijn. Op het kaartje rechts uit 1750 is er maar weinig verschil te
            ontdekken met het kaartje uit 1450. Een aantal straten zijn van naam veranderd. Zo is de Nederheidsche straat de Nieuwstadstraat geworden en de Tyrsstraat de
            Graafseweg. Nieuwe straten zijn er nauwelijks bijgekomen. Wel zijn er wat nieuwe gebouwen bijgekomen, zoals de Lindenholt, Hertekamp, Witte poort en de Roomse kerk aan
            de Dennenstraat. Slot Duvenstein is 't Spijker geworden en Schalunenburg is al verdwenen. In 1675 wordt de status van erfpacht van Neerbosch tenietgedaan (voor
            Lindenholt gebeurd dat pas in het begin van de negentiende eeuw).
          </p>
        </div>
      </div>
      <div className="box main">
        <div className="left">
          <h4>Roomse Kerk aan de Dennenstraat</h4>
          <p>
            De dominicanen of predikheren (Ordo Praedicatorum, O.P.) vormen een kloosterorde die in 1216 is gesticht door Dominicus Guzman (circa 1170-1221), ten tijde van de
            kruistocht in de Languedoc tegen de Katharen. De orde, ook wel de predikbroeders genoemd, had vooral als opdracht het verkondigen van het Evangelie. Dominicus kreeg ook
            vrouwelijke volgelingen. Aanvankelijk waren dat zusters die zich vooral aan stilte en gebed wijdden: Monialen die een contemplatief leven leidden, waarbij het klooster
            niet werd verlaten voor werk buitenshuis. Priesters die behoren tot de orde van de Dominicanen, kunnen volgens de regels van de Kerkelijke heraldiek een leliekruis of
            "croix Fleury" achter hun eventuele wapen plaatsen. In 1672 vestigen de Dominicanen een statie in Neerbosch, vermoedelijk de parochiekerk aan de Dennenstraat.
          </p>
          <p>
            De "Roomse kerk"op de kaart uit 1750 is niet dezelfde kerk als dat nu op deze zelfde plaats staat. De huidige kerk, de St Antonius Abtkerk, is namelijk pas in 1878
            gebouwd. De oude parochiekerk was in een dusdanig vervallen staat dat deze in 1878 afgebroken is en plaats heeft gemaakt voor de huidige kerk.
          </p>
        </div>
        <div className="right">
          <h4>Het kruisbeeld van Neerbosch</h4>
          <p>
            In 1520 werd zoals het nu heet "Het kruisbeeld van Neerbosch" vervaardigd. Dit kruisbeeld is nog altijd aanwezig in de kerk aan de Dennenstraat, alhoewel het kruis zelf
            niet meer oorspronkelijk is. Het oorspronkelijke kruis (stand- en dwarsbalk) bevindt zich nog steeds in de Nikolaikerk te Kalkar (Duitsland). Het beeld is onderdeel van
            3 beelden gemaakt door de zogenaamde "Meester van het Kalkarse Anna-altaar". De andere 2 beelden bevinden zich in de Nikolaikerk te Kalkar. Het beeld is afkomstig uit
            het dominicanenklooster van Kalkar; aldaar was het geenszins een object van speciale verering. Toen het klooster in 1802 door de Fransen was geseculariseerd, werd het
            kruis door pastoor Albertus van Kampen, dominicaan uit het klooster van Kalkar en pastoor te Neerbosch (1790-1817), onmiddellijk met een voerkar naar zijn standplaats
            overgebracht. Pastoor van Kampen schreef in het doopboek van de parochie dat het beeld in januari 1804 aan de parochiekerk in "bruikleen" werd afgestaan.
          </p>
          <p>
            Waarom, wanneer en in welke mate is onbekend, maar het is duidelijk dat het kruisbeeld door een steeds groter wordende groep vereerd wordt. Die speciale verering houdt
            ook nu nog stand. Na de hoogmis staan een tien à vijftiental mensen even stil bij het kruis en per weekend worden er een 100-tal kaarsen bij het kruis geofferd.
          </p>
        </div>
      </div>
      <div className="box light">
        <div className="left">
          <h4>De Witte Poort</h4>
          <p>
            De Witte Poort was een buitengoed aan de Dennenstraat. De naam komt voor het eerst voor in de 17e eeuw. Later wordt de Witte Poort eindstation van de tram om
            uiteindelijk in 1927 gesloopt te worden en plaats te maken voor het St Dominicuscollege wat op die plek gebouwd zal worden. De huidige bebouwing doet nog herinneren aan
            de Witte Poort; via een witte poort bereikt men de binnenplaats.
          </p>
        </div>
        <div className="right">
          <h4>Het Zwaantje</h4>
          <p>
            In het Neerbosch van vandaag kent iedereen het café 't Zwaantje, gelegen aan de St. Agnetenweg, op de hoek met de Zwanenstraat. Dat café ontstond al rond 1660 en heeft
            vele eigenaren gekend. In 1960 werd het gebouw uiteindelijk afgebroken. Het huidige café is dus niet "origineel".
          </p>
        </div>
      </div>
    </div>
  );
}

export default T1450E1750;
